module.exports = __webpack_public_path__ + "static/img/banner.4b01125.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/nals/banner.png
// module id = gNdR
// module chunks = 0